import React from 'react';
import RupeesIcon from '../../assets/images/rupees.svg';
import {CHECKOUT_PATH, HOME_ROUTE_PATH} from '../../routes/route-constants';
import {useHistory} from 'react-router-dom';

type CartInfoProps = {
  children?: React.ReactNode;
  className?: string;
  custType?: string;
  onViewDetailsClicked?: () => void;
  onEmployeeCheckout?: () => void;
  onPushToPos?: () => void;
  onProceed?: () => void;
  onPayNow?: () => void;
  onOrderStatus?: () => void;
  orderButtonVisibility?: boolean;
  totalAmount?: number;
  showViewDetails?: boolean;
  from?: string;
  disabled?: boolean;
};

const CartInfo: React.FC<CartInfoProps> = ({
  className,
  custType,
  orderButtonVisibility,
  onViewDetailsClicked,
  onEmployeeCheckout,
  onPushToPos,
  onProceed,
  showViewDetails,
  totalAmount,
  from,
  onPayNow,
  onOrderStatus,
  disabled,
}: CartInfoProps) => {
  const navigate = useHistory();
  return (
    <div
      className={`${className} py-4 px-6 view-details bg-blue_four absolute bottom-0 left-0 right-0 font-roboto w-full`}>
      <div className="flex justify-between">
        <div>
          <span className="font-medium mr-2">Total</span>
          {showViewDetails && (
            <span
              className="font-bold text-red_zero"
              onClick={onViewDetailsClicked}>
              View Details
            </span>
          )}
        </div>
        <div className="font-medium flex items-center">
          <img src={RupeesIcon} />
          <span className="ml-1">{totalAmount?.toFixed(2)}</span>
        </div>
      </div>
      <div className="border-solid border-gray-300 border-1 mb-2.5"></div>
      {from === 'payment' ? (
        <div>
          {onOrderStatus === undefined ? (
            <div className="flex">
              <button
                onClick={onPayNow}
                disabled={disabled}
                className="text-white h-11 rounded-radius10 mt-2 grid place-items-center focus:outline-none text-center primary normal w-full">
                <p className="font-bold font-roboto">Pay Now</p>
              </button>
            </div>
          ) : (
            <div className="flex">
              <button
                onClick={onOrderStatus}
                className="text-white h-11 rounded-radius10 mt-2 grid place-items-center focus:outline-none text-center primary normal w-full  "
                disabled={orderButtonVisibility}>
                <p className="font-bold font-roboto">Payment Status</p>
              </button>
            </div>
          )}
        </div>
      ) : (
        <div>
          {custType === 'employee' ? (
            <div>
              <div>
                <button
                  onClick={onPushToPos}
                  className="text-white h-11 rounded-radius10 mt-4 grid place-items-center focus:outline-none text-center primary normal w-full ">
                  <p className="font-bold font-roboto">Push to POS</p>
                </button>
              </div>
              <div className="flex justify-between">
                <button
                  onClick={onEmployeeCheckout}
                  className="text-white h-11 rounded-radius10 mt-4 grid place-items-center focus:outline-none text-center primary normal w-3/5">
                  <p className="font-bold font-roboto">Proceed to checkout</p>
                </button>
                <button
                  className="text-white h-11 rounded-radius10 mt-4 grid place-items-center focus:outline-none text-center secondary normal w-35"
                  onClick={() => {
                    navigate.push(CHECKOUT_PATH);
                  }}>
                  <p className="font-bold font-roboto">Shop more</p>
                </button>
              </div>
            </div>
          ) : (
            <div className="flex justify-between">
              <button
                onClick={onProceed}
                className="text-white h-11 rounded-radius10 mt-2 grid place-items-center focus:outline-none text-center primary normal w-3/5">
                <p className="font-bold font-roboto">Proceed to checkout</p>
              </button>
              <button
                className="text-white h-11 rounded-radius10 mt-2 grid place-items-center focus:outline-none text-center secondary normal w-35"
                onClick={() => {
                  navigate.push(CHECKOUT_PATH);
                }}>
                <p className="font-bold font-roboto">Shop more</p>
              </button>
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default CartInfo;
